console.log = function () {};
console.warn = function () {};
console.error = function () {};
console.info = function () {};
console.debug = function () {};